class MockTransactionFactory {
  constructor() {
    this.nextId = 1;
    this.nextAccount = clientAccountsMock[0];
  }

  getNextAccount() {
    for (let i = 0; i < clientAccountsMock.length; i++) {
      const element = clientAccountsMock[i];
      if (this.nextAccount === element) {
        if (i < clientAccountsMock.length - 1) {
          this.nextAccount = clientAccountsMock[i + 1];
          return this.nextAccount;
        } else {
          this.nextAccount = clientAccountsMock[0];
          return this.nextAccount;
        }
      }
    }
  }

  create(company, month, brutoneto, hasVAT) {
    let value = this.nextId % 3 !== 0 ? 200 : -150;
    let accountId = value > 0 ? this.getNextAccount().id : "ostalo";
    return {
      id: this.nextId++,
      company,
      date: `2020-${month < 10 ? "0" : ""}${month}-01`,
      description: value > 0 ? accountId + " ulaz" : "izlaz",
      longDescription: null,
      value,
      currency: 'HRK',
      brutoneto,
      accounts: [accountId],
      createdBy: "zoran",
      createdAt: "2020-10-12T21:19:42.988Z",
      updatedBy: "zoran",
      updatedAt: "2020-10-15T12:48:23.396Z",
      hasVAT,
    };
  }
}

const transactionService = {
  getAll() {
    let transactionFactory = new MockTransactionFactory();
    let transactions = [];
    for (let company of ["pseudocode", "hyperlink", "crud", "cleancode", "aron-pseudocode", "zoran-pseudocode"]) {
      for (let i = 1; i <= 12; i++) {
        transactions.push(transactionFactory.create(company, i, "bruto", false));
        if (company !== "cleancode" && company !== "crud") {
          transactions.push(transactionFactory.create(company, i, "neto", false));
        }
      }
    }
    return Promise.resolve({
      body: transactions,
    });
  },
  get(id) {
    return this.getAll().then((r) => Promise.resolve({ body: r.body.find((t) => t.id === id) }));
  },
  create() {
    throw "not implemented";
  },
};

const clientAccountsMock = [
  { id: "Luckia", typeId: "client" },
  { id: "Typeqast", typeId: "client" },
  { id: "Clubspark", typeId: "client" },
  { id: "Hzz", typeId: "client" },
  { id: "Hrprodigy", typeId: "client" },
  { id: "Integrator", typeId: "client" },
  { id: "Tripadvisor", typeId: "client" },
  { id: "Synergie", typeId: "client" },
  { id: "Manawell", typeId: "client" },
  { id: "ZUC", typeId: "client" },
];

const accountsMock = clientAccountsMock.concat([
  { id: "ostalo", typeId: "ostalo" },
  { id: "ceka uplatu", typeId: "paymentStatus" },
]);

const accountService = {
  getAll() {
    return Promise.resolve({ body: accountsMock });
  },
};

const publisherBlacklistService = {
  get() {
    return Promise.resolve({ body: { blacklistedPublishers: [], publishers: [] } });
  },
  replace(publisherNames) {
    return Promise.resolve({ body: { blacklistedPublishers: publisherNames } });
  },
};

const crawlerSourceService = {
  get() {
    return Promise.resolve({ body: { njuskalo: true, nekretnine: false, index: false } });
  },
  replace(settings) {
    return Promise.resolve({ body: settings });
  },
};

export { transactionService, accountService, publisherBlacklistService, crawlerSourceService };
